import { notification } from 'ant-design-vue'

export default {
  install: (Vue, options) => {
    Vue.prototype.$neoNotify = {
      error: function (error, status = 'error') {
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              notification[status]({
                message: error.response.data.message,
                description: error.response.data.errors[key],
              })
            }
          } else {
            notification[status]({
              message: error.error,
              description: error.response.data.message,
            })
          }
        } else {
          if (error.errors) {
            for (let key in error.errors) {
              notification[status]({
                message: error.message,
                description: error.errors[key],
              })
            }
          } else {
            notification[status]({
              message: 'Something Went wrong',
              description: error.message,
            })
          }
        }
      },
    }
  },
}
